import { useJsApiLoader } from '@react-google-maps/api';
import React from 'react';
const mapsLibraries = ['places'];
const GoogleMapScript = (props) => {
    console.log('Initialize Google API');
    let useVersion = window.MAPS_VER ? window.MAPS_VER : 'weekly';
    const { isLoaded } = useJsApiLoader(Object.assign({ googleMapsApiKey: window.atob(window.MAPS_DATA), version: useVersion, libraries: mapsLibraries, region: window.country, language: props.language ? props.language : window.language, id: 'maps-api' }, props));
    return isLoaded ? props.children : React.createElement(React.Fragment, null);
};
export default GoogleMapScript;
